import { Box } from "@chakra-ui/react";
import { customEvent, getCdnImageSrc } from "goi_common";
import { BaseStack } from "goi_common/src/design-system";
import Image from "next/image";
import { VideoItem } from "../constants/contentData";

interface ContentVideoCardProps {
  item: VideoItem;
}

const LINE_CLAMP_2: React.CSSProperties = {
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
};

const isExternal = (href: string) => href.startsWith("http");

export default function ContentVideoCard({ item }: ContentVideoCardProps) {
  return (
    <Box
      as="a"
      href={item.href}
      target={isExternal(item.href) ? "_blank" : undefined}
      rel={isExternal(item.href) ? "noopener noreferrer" : undefined}
      style={{ display: "block", width: "100%", textDecoration: "none" }}
      onClick={() => {
        customEvent({
          newGtm: {
            path: "content",
            trigger_and_target: `uv_feed-${item.id}`,
          },
        });
      }}
    >
      <BaseStack spacing={12}>
        <Box
          position="relative"
          borderRadius="12px"
          overflow="hidden"
          width="100%"
          background={item.thumbnailBg ?? "#b0b4b9"}
          style={{ aspectRatio: "16/9" }}
        >
          {item.imgSrc && (
            <Image
              src={getCdnImageSrc(item.imgSrc)}
              alt={item.title}
              fill
              style={{ objectFit: "cover" }}
            />
          )}
        </Box>
        <BaseStack spacing={6}>
          <Box className="headline_1_sb gray900" style={LINE_CLAMP_2}>
            {item.title}
          </Box>
          <Box className="body_1_normal_r gray500" style={LINE_CLAMP_2}>
            {item.description}
          </Box>
          <Box style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
            {item.tags.map((tag) => (
              <Box
                key={tag}
                style={{
                  background: "#ffffff",
                  border: "1px solid #dddedf",
                  borderRadius: "4px",
                  padding: "4px 6px",
                  fontSize: "12px",
                  fontWeight: 400,
                  color: "#46494c",
                  lineHeight: "16px",
                  letterSpacing: "-0.1px",
                }}
              >
                {tag}
              </Box>
            ))}
          </Box>
        </BaseStack>
      </BaseStack>
    </Box>
  );
}
